// @flow
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';
import {
  getDimensionFieldPathForEstimateCC,
  getDiscountBoundsCheckForEstimateCC,
  getIfDiscountIsEditableForMetricAndUserTypeForEstimateCC,
  getIfGivenRowIsBeingEditedORANewOneForEstimateCC,
} from '@components/committed-capacity/utils';

import { TextField } from '../../../formik-utils/FormFields';
import { TEXT_NUMBER_INPUT_TYPE } from '../../../formik-utils/consts';
import { IS_ROW_OPENED_FOR_EDITING } from '../../../constants';
import { useIsUserAdmin } from '../../../custom-hooks/useIsUserAdmin';
import { useIsRowInputDisabledForEstimateCC } from '../../../custom-hooks/useIsRowInputDisabledForEstimateCC';
import { EstimateContext } from '../../../contexts/EstimateContext';
import { ESTIMATE_COMMITTED_CAPACITY } from '../enums';
import { WarningMessageContainer } from '../../presentational/messages/WarningMessageContainer';

export const DiscountContainerForEstimateCC = ({
  dimensionRow,
  metricRow,
  configuredMetrics,
  metricIndex,
  dimensionIndex,
}) => {
  const { setFieldValue } = useFormikContext();
  const isUserAdmin = useIsUserAdmin();

  const estimateData = useContext(EstimateContext);

  const isRowInputDisabled = useIsRowInputDisabledForEstimateCC({
    dimensionRow,
    metricName: metricRow.metricName,
    configuredMetrics,
  });

  // Some metrics (see isDiscountEditableByNonAdmins in the metric config) keep % Discount at a
  // pre-approved value for non-admins; admins can always edit it.
  const isDiscountEditableForUser = getIfDiscountIsEditableForMetricAndUserTypeForEstimateCC(
    metricRow.metricName,
    isUserAdmin
  );
  const shouldDiscountBeDisabled = !isDiscountEditableForUser || isRowInputDisabled;

  const discountPath = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    ESTIMATE_COMMITTED_CAPACITY.DISCOUNT_BACKEND_FIELD_NAME
  );
  const inProgressFieldName = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    IS_ROW_OPENED_FOR_EDITING
  );

  const metricName = metricRow.metricName;
  const isRowBeingEdited = getIfGivenRowIsBeingEditedORANewOneForEstimateCC(dimensionRow);
  const discountValue = dimensionRow[ESTIMATE_COMMITTED_CAPACITY.DISCOUNT_BACKEND_FIELD_NAME];

  const { minDiscount, maxDiscount, isOutOfBounds } = getDiscountBoundsCheckForEstimateCC(
    metricName,
    discountValue,
    estimateData,
    dimensionRow
  );

  const shouldShowWarning =
    isRowBeingEdited && discountValue != null && isOutOfBounds && isUserAdmin;

  return (
    <>
      <TextField
        addLabel={false}
        disableOnFormErrors={false}
        disabled={shouldDiscountBeDisabled}
        fieldDisplayName={ESTIMATE_COMMITTED_CAPACITY.DISCOUNT_DISPLAY_NAME}
        fieldName={discountPath}
        onChange={async () => {
          await setFieldValue(inProgressFieldName, true);
        }}
        placeholder={ESTIMATE_COMMITTED_CAPACITY.DISCOUNT_DISPLAY_NAME}
        type={TEXT_NUMBER_INPUT_TYPE}
      />
      {shouldShowWarning && (
        <WarningMessageContainer
          message={`Discount is outside the permitted range of ${minDiscount}% - ${maxDiscount}%. You can still proceed with saving if you are sure!`}
        />
      )}
    </>
  );
};
